//** NEW TEMPLATE
import React, { useEffect, useState, useCallback, useRef } from "react";
import { injectIntl } from "react-intl";
import { withRouter, Link } from "react-router-dom";
import Routes from "../../Routes";
import renderLangString from "../../languageStrings";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import ACTIONS from "../../actions/types";

// HOC
import NewAppHOC from "../../hoc/NewAppHOC";
import ErrorHOC from "../../hoc/ErrorHOC";

// COMPONENTS
import MainAsideNav from "../../components/navigations/MainAsideNav";
import HelperAsideNav from "../../components/navigations/HelperAsideNav";
import Main from "../../components/main/Main";
import MainNav from "../../components/navigations/MainNav";
import UserNav from "../../components/navigations/UserNav";
import AlphaTable from "../../components/tables/AlphaTable";
import AnimateLayout from "../../components/layout/AnimateLayout";
import Title from "../../components/text/Title";
import Message from "../../components/alerts/Message";
import Layout from "../../components/layout/Layout";
import Icon from "../../components/icons/Icon";

// FUNCTIONS
import AJAX from "../../functions/ajax";
import ParseHTML from "../../functions/ParseHTML";
import validateData from "../../functions/validateData";

// DATA MODEL
import collectionDataModel from "../../data_model/review_admin/collection/collection";
import stageCollectionsDataModel from "../../data_model/review_admin/collection/all_collections";

function Collection({ match, history, intl }) {
  const isInitialMount = useRef(false);
  const _id = 4902384203480;
  const dispatch = useDispatch();

  const [counterData, setCounterData] = useState();
  const [collectionData, setCollectionData] = useState();
  const [tableData, setTableData] = useState();
  const [reviewStageCollections, setReviewStageCollections] = useState();
  const [reviewers, setReviewers] = useState();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const reduxState = useSelector(state => state);
  const sizeOfTheScreen = useSelector(store => store.app.sizeOfTheScreen);

  const getMenuData = id => {
    AJAX()
      .getReviewStage(_id, reduxState, id)
      .then(res => {
        const isDataValid = validateData(
          "ReviewAdmin > Collection >  AJAX().getReviewStage",
          res,
          stageCollectionsDataModel
        );

        if (isDataValid) {
          setReviewStageCollections(res.data.stage.collections);
        }
      });
  };

  const getMainData = () => {
    AJAX()
      .getReviewCollection(_id, reduxState, match.params.id)
      //.get(_id, "https://alphaawards-aca8b.firebaseio.com/app/admin_collection.json")
      .then(res => {
        const isDataValid = validateData(
          "ReviewAdmin > Collection > AJAX().getReviewCollection",
          res,
          collectionDataModel
        );

        if (isDataValid) {
          const data = res.data.collection;

          getMenuData(data.stage_id);

          setCollectionData(data);

          setTableData(data.cases_table);
          setIsConfirmed(data.confirmed);
          dispatch({
            type: ACTIONS.SET_PAGE_IDS,
            payload: { stage: data.stage_id, collection: data.id },
          });

          // get reviewers
          AJAX()
            .get(_id, data.assignments_url)
            .then(res => {
              if (res.data.data.length !== 0) {
                if (reduxState.app.sizeOfTheScreen === "desktop") {
                  dispatch({ type: ACTIONS.SHOW_HELLPER_SIDE_NAV });
                }
                setReviewers(res.data.data);
              }
            });
        }
      });
  };

  const init = useCallback(() => {
    getMainData();
    dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_PRESENT });
    sizeOfTheScreen !== "mobile" && dispatch({ type: ACTIONS.SHOW_HELLPER_SIDE_NAV });
  }, [getMainData, sizeOfTheScreen]);

  // run once on page load
  useEffect(init, []);

  // on route change
  useEffect(() => {
    if (isInitialMount.current) {
      getMainData();
    } else {
      isInitialMount.current = true;
    }
  }, [match]);

  useEffect(() => {
    if (reduxState.reviewer && reduxState.reviewer.expiresAt) {
      setCounterData(reduxState.reviewer.expiresAt);
    }
  }, [reduxState]);

  const handleNavItemClick = () => {
    dispatch({ type: ACTIONS.HIDE_MAIN_MENU_ON_TOP });
  };

  // run on unmount
  useEffect(() => {
    return () => {
      AJAX().cancelRequest(_id);
      dispatch({ type: ACTIONS.HIDE_HELLPER_SIDE_NAV });
      dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_NOT_PRESENT });
    };
  }, [_id]);

  return (
    <NewAppHOC>
      <MainAsideNav>
        {/* <AnimateLayout animate={collectionData} addClass="__n_bs"> */}
        <div className="__n_bs">
          <Link to="/ui/review_admin/dashboard">
            <Layout flex>
              <div>
                <Icon
                  iconId="categoriesFull"
                  addClass="c1 __n_bi"
                  style={{ marginRight: ".7rem" }}
                />
              </div>
              <Title tagName="h1" addClass="c16" removeWeight>
                {intl.formatMessage({ id: "reviewAdminDashboard" })}
              </Title>
            </Layout>
          </Link>
          {collectionData && (
            <div>
              <Link to={`/ui/review_admin/stage/${collectionData.stage_id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="categoriesFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="span" removeWeight addClass="c16">
                    {collectionData.breadcrumbs.stage.title}
                  </Title>
                </Layout>
              </Link>
              <Link to={`/ui/review_admin/collection/${collectionData.id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="listFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="h1" addClass="c16">
                    {collectionData.title}
                  </Title>
                </Layout>
              </Link>
              <ParseHTML html={collectionData.description} />
            </div>
          )}
          {reviewStageCollections && (
            <MainNav
              clicked={handleNavItemClick}
              title={renderLangString({ id: "$_m" })}
              data={reviewStageCollections}
              linkTo={Routes.reviewAdminCollection().path}
              activeItem={match.params.id}
            />
          )}
        </div>
        {/* </AnimateLayout> */}
      </MainAsideNav>
      <Main counter={counterData}>
        {/* <AnimateLayout animate={collectionData}> */}
          {tableData && tableData.data.length !== 0 ? (
            <ErrorHOC crashPage>
              <AlphaTable data={tableData} dontRenderAlerter />
            </ErrorHOC>
          ) : (
            <Message msg={renderLangString({ id: "$_d8" })} />
          )}
        {/* </AnimateLayout> */}
      </Main>
      <HelperAsideNav preventFromClosing>
        {/* <AnimateLayout animate={collectionData}> */}
          <Title style={{ marginBottom: "3.5rem" }}>{renderLangString({ id: "$_b4" })}</Title>

          {reviewers && reviewers.length !== 0 && (
            <UserNav list={reviewers} popoverStatsFor="judges" />
          )}
          {!reviewers || (reviewers && reviewers.length === 0) ? (
            <Message msg={renderLangString({ id: "$_d5" })} textOnly />
          ) : null}
        {/* </AnimateLayout> */}
      </HelperAsideNav>
    </NewAppHOC>
  );
}

export default injectIntl(withRouter(Collection));
